module.exports = __webpack_public_path__ + "static/media/jaaa.b1a89e73.ogg";